const submissionFormsUpgradeMode = {
    NO_UPGRADE_SUBMISSION_FORMS : 1,

    AUTO_UPGRADE_SUBMISSION_FORMS : 2,

    MANUAL_UPGRADE_SUBMISSION_FORMS : 3

};

angular.module('gw-um-j2js')
    .constant('submissionFormsUpgradeMode', submissionFormsUpgradeMode);